import { SideMenuTopic } from '@/const/SideMenuTopic'

/**
 * システム管理者用サイドメニューに表示する項目の定義
 */
export namespace AdminSideMenuTopic {
  /** 塾一覧 */
  // TODO: 遷移先画面実装後にURL修正
  const ACADEMY_LIST: Topic = {
    text: '塾管理',
    icon: '/img/icon/manage/sidemenu/academy_list.svg',
    url: '/admin/academies',
  }

  /** 塾管理者一覧 */
  const USER_ACADEMY_LIST: Topic = {
    text: 'ユーザ管理',
    icon: '/img/icon/manage/sidemenu/user_academy_list.svg',
    url: '/admin/academy/users',
  }

  /** お知らせ */
  const NOTICE: Topic = {
    text: 'お知らせ',
    icon: '/img/icon/manage/sidemenu/notice.svg',
    url: '/admin/notice',
    subUrls: ['/admin/notice/.*'],
  }

  /** メニュー項目一覧 */
  export const LIST: Topic[] = [ACADEMY_LIST, USER_ACADEMY_LIST, NOTICE]

  /** メニュー項目の型 */
  export type Topic = SideMenuTopic.Topic
}
